import PropTypes from 'prop-types';
import React from 'react';

const Bubble = ({ onClick, text = '', type = 'info' }) => (
  <div
    className={`bubble bubble--${type}`}
    onClick={onClick}
  >
    {text}
  </div>
);

Bubble.propTypes = {
  onClick: PropTypes.func,
  text: PropTypes.string,
  type: PropTypes.string
};

export default Bubble;
